import React from 'react';
import { Field, useFormState, useForm } from 'react-final-form';
import { FormControlLabel, IconButton, Checkbox } from '@material-ui/core';
import VpnKeyIcon from '@material-ui/icons/VpnKey';

const CheckboxWrapper = ({ input: { checked, name, onChange, ...restInput }, meta, configFieldName, onClickHandler, ...rest }) => {
	const { values } = useFormState();
	const form = useForm();

	const handleChange = (e) => {
		const newValue = e.target.checked;
		onChange(newValue);

		if (onClickHandler && values?.config) {
			onClickHandler(values.config, configFieldName, newValue, form);
		}
	};

	return (
		<Checkbox {...rest} name={name} inputProps={restInput} onChange={handleChange} checked={checked}/>
	);
};

const ConfigCheckboxField = ({
	name,
	displayName,
	onLaunchViamente,
	configFieldName,
	disabled,
	onClickHandler,
}) => (
	<>
		<FormControlLabel
			control={
				<Field
					name={`${name}.value`}
					component={CheckboxWrapper}
					type="checkbox"
					disabled={disabled}
					configFieldName={configFieldName}
					onClickHandler={onClickHandler}
				/>
			}
			label={displayName}
		/>
		{configFieldName === 'routeopt' && (
			<Field name={`${name}.value`}>
				{({ input: { value } }) => (
					<IconButton disabled={!value} onClick={onLaunchViamente}>
						<VpnKeyIcon />
					</IconButton>
				)}
			</Field>
		)}
	</>
);

export default ConfigCheckboxField;
